import React, { FC } from 'react'
import {
  ActionWrapper,
  ActivateAction,
  ContainerActionItem,
  InactiveAction,
  PendingAction,
  PendingActions,
  ResendActivationButton,
} from './styled'
import DisassociateIcon from 'assets/icons/DIsassociate'
import RollBackIcon from 'assets/icons/RollBackIcon'
import PendingIcon from 'assets/icons/PendingIcon'

interface ActionItemProps {
  id: number
  active?: boolean
  handleActivateActionClick: (id: number) => void
  handleResendActivationClick: (id: number) => void
  handleSuspendActionClick: (id: number) => void
  handleDeleteActionClick: (id: number, idStatus: number) => void
  handleEditActionClick?: (id: number) => void
  isDisableActionItem?: boolean
  onClick?: (id: number) => void
  idStatus?: number
  resendingActivationUserId?: number | null
  request_status: string | null
}

const ActionItem: FC<ActionItemProps> = ({
  id,
  active = false,
  handleActivateActionClick,
  handleResendActivationClick,
  handleSuspendActionClick,
  handleDeleteActionClick,
  // handleEditActionClick,
  isDisableActionItem = false,
  idStatus,
  resendingActivationUserId = null,
  // request_status: requestStatus,
}) => {
  const isResendingActivation = resendingActivationUserId === id
  const isResendDisabled = isDisableActionItem || resendingActivationUserId !== null

  return (
    <ContainerActionItem>
      {!active && idStatus !== 3 ? (
        <>
          {
            idStatus === null ? (
              <PendingActions>
                <ActionWrapper onClick={() => { handleDeleteActionClick(id, 3) }}>
                  <PendingIcon color="#C2C2C2" />
                  <PendingAction isDisable={isDisableActionItem}>Por Activar</PendingAction>
                </ActionWrapper>
                <ResendActivationButton
                  type="button"
                  disabled={isResendDisabled}
                  onClick={() => { handleResendActivationClick(id) }}
                >
                  {isResendingActivation ? 'Reenviando...' : 'Reenviar activación'}
                </ResendActivationButton>
              </PendingActions>
            ) : (
              <PendingActions>
                <ActionWrapper
                  onClick={() => {
                    handleActivateActionClick(id)
                  }}>
                  <RollBackIcon color={isDisableActionItem ? '#C2C2C2' : '#2D749C'} />
                  <ActivateAction isDisable={isDisableActionItem}>Reactivar</ActivateAction>
                </ActionWrapper>
                <ResendActivationButton
                  type="button"
                  disabled={isResendDisabled}
                  onClick={() => { handleResendActivationClick(id) }}
                >
                  {isResendingActivation ? 'Reenviando...' : 'Reenviar activación'}
                </ResendActivationButton>
              </PendingActions>
            )
          }
        </>
      ) : idStatus === 3 ? (
        <PendingActions>
          <ActionWrapper onClick={() => handleDeleteActionClick(id, idStatus)}>
            <PendingIcon color="#C2C2C2" />
            <PendingAction isDisable={isDisableActionItem}>Por Activar</PendingAction>
          </ActionWrapper>
          <ResendActivationButton
            type="button"
            disabled={isResendDisabled}
            onClick={() => { handleResendActivationClick(id) }}
          >
            {isResendingActivation ? 'Reenviando...' : 'Reenviar activación'}
          </ResendActivationButton>
        </PendingActions>
      ) : (
        <PendingActions>
          <ActionWrapper
            onClick={() => {
              handleSuspendActionClick(id)
            }}
          >
            <DisassociateIcon color={isDisableActionItem ? '#C2C2C2' : '#E44646'} />
            <InactiveAction isDisable={isDisableActionItem}>Suspender</InactiveAction>
          </ActionWrapper>
          <ResendActivationButton
            type="button"
            disabled={isResendDisabled}
            onClick={() => { handleResendActivationClick(id) }}
          >
            {isResendingActivation ? 'Reenviando...' : 'Reenviar activación'}
          </ResendActivationButton>
        </PendingActions>
      )}
    </ContainerActionItem>
  )
}

export default ActionItem
